'use client';

import { useSyncExternalStore } from 'react';
import { useYotpoRefresh } from '@/lib/hooks/useYotpoRefresh';

const SEO_WIDGET_INSTANCE_ID = '1006620';

/**
 * Yotpo's loader populates `.yotpo-widget-instance` as soon as it runs, which
 * on this page happened before React finished hydrating. React then found a
 * node it had server-rendered empty now carrying `data-yotpo-element-loaded`,
 * `data-v-app` and the whole injected widget tree, reported a hydration
 * mismatch, and regenerated the subtree — discarding the widget and leaving an
 * empty div behind.
 *
 * Mounting the container only after hydration removes the race entirely: React
 * creates the node itself, so there is nothing for it to mismatch against, and
 * Yotpo fills a node React has already committed. Same approach as
 * YotpoProductReviewsClient on the PDP.
 */
const AllProductReviewsClient = () => {
  const mounted = useSyncExternalStore(() => () => {}, () => true, () => false);

  // The loader may not have exposed initWidgets yet when the node appears, and
  // its observer can miss a node added this late — the hook polls and calls it.
  useYotpoRefresh(mounted);

  // Reserve height while waiting so the widget doesn't shift the page in.
  if (!mounted) return <div className="min-h-[400px]" />;

  return (
    <div
      className="yotpo-widget-instance"
      data-yotpo-instance-id={SEO_WIDGET_INSTANCE_ID}
    />
  );
};

export default AllProductReviewsClient;
